export default {
  locked: {
    en: 'Locked',
  },
  unlocked: {
    en: 'Unlocked',
  },
}
